import { localStorageGet } from '@/helpers/localStorage';

/**
 * Checks local storage to see if we have an affiliate_check flag.
 * @returns {boolean}
 */
export const hasAffiliateBeenChecked = () => localStorageGet('affililate_check') === 'complete';
